import React from "react";
import { multitenancyTerms } from "multitenancy/multitenancyContactInfo";

import { useTranslation } from 'react-i18next';

import "./style.scss";

export const TermsAndConditionsFooter = () => {

  const { t } = useTranslation();

  return (
    <div className="terms-footer-container">
      <div className="terms__text">
        {t("By signing in, you agree to our")} &nbsp;
        {multitenancyTerms()}
      </div>
    </div>
  )
}